var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { Base, createApp } from "@studiometa/js-toolkit";
import { isDev } from "./config";
import HeroSlider from "./components/HeroSlider";
import Gallery from "./components/Gallery";
import Accordion from "./components/Accordion";
class App extends Base {
  mounted() {
    this.$log("mounted \u{1F389}");
    document.querySelector(".burger").addEventListener("click", this.handleMenu);
  }
  handleMenu() {
    document.querySelector("body").classList.toggle("menuIsOpen");
  }
}
__publicField(App, "config", {
  log: isDev(),
  name: "App",
  components: {
    HeroSlider,
    Gallery,
    Accordion
  }
});
var app_default = createApp(App, document.body);
export {
  app_default as default
};


if (module.hot) {module.hot.accept(function(err) {
if (err) {
console.error(err);
}
});
}
